<div class="notifications-holder {{ documentDirection }}" *ngIf="notifications$ | async as notifications">
    <section class="controller" *ngIf="!isMainPage">
        <serviceos-ng-link
            (click)="navigateTo('notifications')"
            [size]="'small'"
            [font_weight]="'semi-bold'"
        >
            <span *ngIf="moduleCustomerTexts$ | async as moduleCustomerTexts">
                {{ moduleCustomerTexts.view_all ? moduleCustomerTexts.view_all : 'View all' }}
            </span>
        </serviceos-ng-link>
        <span class="holder" *ngIf="unclosedNotifications$ | async as unclosedNotifications">

            <span class="close-all" *ngIf="unclosedNotifications && unclosedNotifications.length" (click)="closeAllNotifications()">
                <span *ngIf="moduleCustomerTexts$ | async as moduleCustomerTexts">
                    {{ moduleCustomerTexts.close_all ? moduleCustomerTexts.close_all : 'Close all' }}
                </span>
            </span>
        </span>
    </section>
    <ng-container *ngFor="let notification of notifications; let i=index">
        <div *ngIf="isMainPage || (i < limit && !notification.closed)" class="notification {{notification.messageType}}">
            <div class="message-holder">
                <p class="message">
                    {{ notification.messageType === 'bookings_unrated_notice' ? notification.message + ' ' +
                    notification.serviceTitle + ' ' + notification.messageTwo : notification.message }}
                </p>
            </div>
            <div class="link-holder" [ngClass]="{'no-close': isMainPage}">
                <serviceos-ng-link [type]="'secondary'" [font_weight]="'semi-bold'" [size]="'small'" class=""
                    (click)="onNotificationClick(notification)">
                    {{ notification.button }}
                </serviceos-ng-link>
            </div>
            <div class="close-button-holder" *ngIf="!isMainPage">
                <serviceos-ng-system-icon (click)="onNotificationClose(notification)" class="close-button"
                    [icon]="'close-circle'"></serviceos-ng-system-icon>
            </div>
        </div>
    </ng-container>
    <serviceos-ng-local-loader [showLoader]="requestInProgress"></serviceos-ng-local-loader>
    <div *ngIf="unclosedNotifications$ | async as unclosedNotifications">
        <div class="no-notifications-holder" *ngIf="!isMainPage && !unclosedNotifications.length && !requestInProgress && texts">
            <div class="text-holder">
                <p>{{ texts.missing_notifications }} </p>
            </div>
            <div class="image-holder">
                <img [src]="missingNotificationsImg$ | async">
            </div>
        </div>
    </div>
    <serviceos-ng-local-loader [showLoader]="showLocalLoader"></serviceos-ng-local-loader>
</div>

<!-- backup no image section -->
<!-- <ng-template #noNotificationsElement>
    <div class="no-notifications-holder" *ngIf="!requestInProgress && texts">
        <div class="text-holder">
            <p>{{ texts.missing_notifications }} </p>
        </div>
        <div class="image-holder">
            <img [src]="missingNotificationsImg$ | async">
        </div>
    </div>
</ng-template> -->